import React from 'react';

const ChefLocationsNav = props => {
  const { subject: chef, isMobile } = props;
  const { service_district_subsections: service_districts = [] } = chef;
  return (
    <div className="on-boarding-nav-item__body">
      {isMobile ? (
        <span className="on-boarding-nav-item__menu--count">
          {service_districts.length}
        </span>
      ) : (
        service_districts
          .map(d => d.name)
          .sort()
          .map((name, i) => (
            <p key={i} className="p">
              {name}
            </p>
          ))
      )}
    </div>
  );
};

export default ChefLocationsNav;



// WEBPACK FOOTER //
// ./src/components/onboarding/chef/ChefLocationsNav.js